import { useState, useEffect } from 'react';

const WALLETS = [
  '0x742d35Cc6634C0532925a3b844Bc9e7595f8dEe3',
  '0x8ba1f109551bD432803012645Aac136c82C3e8C9',
  '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
  '0x514910771AF9Ca656af840dff83E8264EcF986CA',
  '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
  '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
  '0x9A8Bcc5d9F83A3c9E4F8E5b7a4b83c64Dc0bF120',
  '0x3f5CE5FBFe3E9af3971dD833D26bA9b5C936f0bE',
];

const EVENT_TYPES = ['DEPOSIT', 'CLAIM', 'REINVEST', 'REFERRAL'];

const PLAN_DAYS = [1, 5, 10, 15, 20, 25, 30];

const generateMockEvents = (count = 20) => {
  const now = Date.now();
  const events = [];

  for (let i = 0; i < count; i++) {
    const wallet = WALLETS[Math.floor(Math.random() * WALLETS.length)];
    const type = EVENT_TYPES[Math.floor(Math.random() * EVENT_TYPES.length)];
    const plan = PLAN_DAYS[Math.floor(Math.random() * PLAN_DAYS.length)];

    let amount;
    if (type === 'DEPOSIT' || type === 'REINVEST') {
      amount = Math.floor(Math.random() * 19500) + 500;
    } else if (type === 'CLAIM') {
      amount = Math.floor(Math.random() * 4900) + 100;
    } else {
      amount = Math.floor(Math.random() * 1900) + 20;
    }

    events.push({
      id: `ev_${now}_${i}`,
      type,
      wallet,
      walletShort: `${wallet.slice(0, 6)}…${wallet.slice(-4)}`,
      amount,
      plan: type === 'DEPOSIT' || type === 'REINVEST' ? plan : null,
      gen: type === 'REFERRAL' ? Math.floor(Math.random() * 17) + 1 : null,
      timestamp: now - Math.floor(Math.random() * 3600_000),
    });
  }

  return events.sort((a, b) => b.timestamp - a.timestamp);
};

export const useBscTransactions = (refreshInterval = 30000) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTransactions = async ({ silent = false } = {}) => {
    try {
      if (!silent) setLoading(true);
      const mock = generateMockEvents(20);
      setTransactions(mock);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      if (!silent) setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
    const interval = setInterval(() => fetchTransactions({ silent: true }), refreshInterval);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshInterval]);

  return { transactions, loading, error, refetch: fetchTransactions };
};
